export default __webpack_public_path__ + "static/media/image-chair-algo-d-2-w.50abfc44.webp";